import {openLightbox} from 'wix-window';
import {prefetchPageResources} from 'wix-site';
import {log, savePolicy, getPolicy} from 'public/biLogger';

const switchId = "#switch2";
const successText = "#text21";
const errorText = "#text22";
const button = "#button1";
let successTimeout;

let currentPolicy;

function showSucces(){
  $w(successText).show();
  successTimeout = setTimeout(() => {
    hideTexts();
  }, 3000)
}

function disableButton(){
  $w(button).disable();
}

function enableButton(){
  $w(button).enable();
}

function disableToggle(){
  $w(switchId).disable();
}

function enableToggle(){
  $w(switchId).enable();
}

function defineButtonState(newPolicy){
   if(newPolicy !== currentPolicy){
     enableButton();
   }else{
     disableButton();
   }
}

function hideTexts(){
  $w(successText).hide();
  $w(errorText).hide();
}

$w.onReady(function () {
  hideTexts();
  disableButton();
  prefetchPageResources({
      "lightboxes": ["Cookie Settings"]
  });
  //This is for making sure that it doesn't run on the server, setTimeout is noopified there
  setTimeout(() => {
    const { defaultPolicy,advertising} = getPolicy();
    if(!defaultPolicy){
      $w(switchId).checked = advertising;        
      currentPolicy = advertising;
    }else{
      enableButton();
    }
  }, 0);

	$w(switchId).onChange(()=> {
    toggelAction();
	});

	$w(button).onClick(()=> {
		saveAction();
	});
});

function toggelAction(){
  const advertising = $w(switchId).checked;
  toggleBi(advertising);
  if(advertising !== currentPolicy && !advertising){
    openLightbox('Cookie Settings').then(lightBoxDecisionHandler);
  }
  defineButtonState(advertising);
}

function lightBoxDecisionHandler(advertisingDecision){
  let action = advertisingDecision && advertisingDecision.action || 'dismiss';
  log({ evid: 818, action });
  const advertising = action === 'ok';
  if(advertising){
    $w(switchId).checked = true;
  } 
  defineButtonState(advertising);
}

function saveAction(){
  hideTexts();
  disableButton();
  
  const advertising = $w(switchId).checked;
  disableButton();
  disableToggle();

  savePolicy(advertising).then(()=>{
    showSucces();
    currentPolicy = advertising;
    enableToggle();
  }).catch(()=> {
    $w(errorText).show();
    enableButton();
    enableToggle();
  });
  saveBi(advertising);
}

function toggleBi(advertising){
	log({action: 'toggle', toggle: advertising, evid: 817});
}

function saveBi(advertising){
	log({ action: 'save', toggle: advertising, evid: 817});
}
